module.exports = __webpack_public_path__ + "static/media/icon-menu-documents-active.4a05b2ab.svg";